import React from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import CustomToolbar from '../../common/datagrid/CustomToolbar';
import CustomLoadingOverlay from '../../common/datagrid/CustomLoadingOverlay';

const EtcList = ({
  apiRef,
  columns,
  rows,
  error,
  loading,
  handleRowEditStart,
  handleRowEditStop,
  handleCellFocusOut,
}) => {
  return (
    <div style={{ display: 'flex', height: '300px' }}>
      <div style={{ flexGrow: 1 }}>
        <DataGridPro
          apiRef={apiRef}
          rows={rows ? rows : []}
          columns={columns}
          components={{
            Toolbar: CustomToolbar,
            LoadingOverlay: CustomLoadingOverlay,
          }}
          componentsProps={{
            toolbar: { fileName: '기타관계리스트' },
          }}
          loading={loading}
          editMode="row"
          onRowEditStart={handleRowEditStart}
          onRowEditStop={handleRowEditStop}
          onCellFocusOut={handleCellFocusOut}
          initialState={{ pinnedColumns: { right: ['actions'] } }}
        />
      </div>
    </div>
  );
};

export default EtcList;
